import React from "react";
import NextImage from "next/image";

import Typography from "@/foundation/Typography/V2";

function ShyftPassFooter({ baseUrl = "/shyftpass/" }) {
  return (
    <footer className="footer-wrapper">
      <div className="footer-container ">
        <div className="footer__top">
          <div className="footer__top-first-column">
            <a href={baseUrl?.endsWith("/") ? baseUrl : `${baseUrl}/`}>
              <div className="logo-container">
                <NextImage
                  className="brand-logo-web"
                  alt=""
                  src="https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyft-pass-logo-footer.png"
                  fill={true}
                />
              </div>
            </a>
          </div>
          <div className="footer__top-second-column">
            <a href="/" rel="noreferrer">
              <p>About Shyft</p>
            </a>
            <Typography
              variant="routelink2"
              to={`${baseUrl}#shyft-pass-how-it-works`}
              rel="noreferrer"
            >
              <p>How it works</p>
            </Typography>
            <Typography
              variant="routelink2"
              to={`${baseUrl}#shyft-pass-workout-schedule`}
            >
              <p>Schedule</p>
            </Typography>
            <a href="/contact-us/" rel="noreferrer">
              <p>Contact us</p>
            </a>
            <Typography
              variant="routelink2"
              to={`${baseUrl}#shyft-pass-faq`}
              rel="noreferrer"
            >
              <p>FAQ</p>
            </Typography>
            <a href="/terms-condition/">
              <p>Terms & Conditions</p>
            </a>
          </div>
          <div className="footer__top-third-column">
            <p>
              Download the Shyft app to get started with your wellness journey
            </p>
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=com.mindhouse"
                target="_blank"
                rel="noreferrer"
              >
                <div className="app-logo-container">
                  <NextImage
                    alt=""
                    src="https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyft-pass-google-play-footer.png"
                    fill={true}
                  />
                </div>
              </a>
              <a
                href="https://apps.apple.com/in/app/mindhouse-modern-meditation/id1484471377"
                target="_blank"
                rel="noreferrer"
              >
                <div className="app-logo-container">
                  <NextImage
                    alt=""
                    src="https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyft-pass-apple-play-footer.png"
                    fill={true}
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <p className="footer__bottom-text">
            © Blacktail Mindhouse Inc. All rights reserved. Our website
            services, content, and products are for informational purposes only.
            Shyft does not provide medical advice, diagnosis, or treatment. See
            additional information.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default ShyftPassFooter;
